import { createSelector } from 'reselect'
import { getArrayOfObjectValues } from '../../utils';

export const getEquipmentSelector = createSelector(
  equipment => equipment.equipment,
  (equipmentById) => getArrayOfObjectValues(equipmentById)
);